document.addEventListener('DOMContentLoaded', function() {
  const contactButtons = document.querySelectorAll('a[href*="contact"]');
  
  contactButtons.forEach(button => {
    const originalHref = button.getAttribute('href');
    
    // Skip if already modified or invalid
    if (!originalHref || originalHref.includes('?source=')) return;
    
    // Replace shopify:// reference and add source param
    const normalizedHref = originalHref.replace('shopify://pages/contact', '/pages/contact');
    const separator = normalizedHref.includes('?') ? '&' : '?';
    const sourceUrl = encodeURIComponent(window.location.href);
    
    button.setAttribute('href', normalizedHref + separator + 'source=' + sourceUrl);
  });
});